export const scrollToId = (id) => {
  const target = document.getElementById(id);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -104 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};

export const openInquiry = () => window.dispatchEvent(new CustomEvent("open-inquiry"));
